import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { ModalFrame } from "./ModalFrame.js";
const SlideOver = React.forwardRef(function SlideOver2(props, ref) {
  return /* @__PURE__ */ jsx(ModalFrame, { ref, surfaceClass: "ev-slide-over", ...props });
});
SlideOver.displayName = "SlideOver";
export {
  SlideOver
};
//# sourceMappingURL=SlideOver.js.map
